// Vue plugin <eui-collapsible>:

'use strict';

import { euiGeneriskKryssrutaMixin } from 'v-mixins/euiGeneriskKryssrutaMixin';

import euiMaintainDisabled from 'v-directives/euiMaintainDisabled';


const plugin = {

	install(Vue, options) {

		Vue.component('eui-collapsible', {

			// All generisk kryssrutefunktionalitet, se 'euiGeneriskKryssrutaMixin.js'.
			// Props:		vpPaslagen, vpInaktiverad, vpOsynlig, vpTooltip, vpAccessKey
			// Data:			uniktId, mixinIsMounted, mixinIsMountedAndNextTick, mixinIsMountedAndSecondNextTick
			// Computed:	skaVaraOsynlig, skaVaraInaktiverad
			// Events:	andrad
			// Model:	vpPaslagen, andrad
			mixins: [euiGeneriskKryssrutaMixin],

			// @click.stop.prevent hindrar webbläsarens egna toggling, vilket förhindrar att den får en fokusring vid just klick (den ska få det vid tabbning):
			template: `
				<div class="_eui-collapsible" :class="{ '-paslagen':vpPaslagen, '-osynlig':skaVaraOsynlig }" :disabled="skaVaraInaktiverad" :data-id="dataId">
					<input :id="uniktId" :checked="vpPaslagen" :disabled="skaVaraInaktiverad" type="checkbox" :title="vpTooltip" :data-id="dataId">
					<label class="_eui-collapsible_label" :for="uniktId" @click.stop.prevent="onChange" :title="vpTooltip">

						<slot name="header"></slot>

						<svg class="_eui-collapsible_chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
							 :style="chevronStyle"
						>
							<polyline points="6 9 12 15 18 9"
								:style="chevronPictogramStyle"
							></polyline>
						</svg>
					</label>

					<div class="_eui-collapsible_content"
						v-eui-maintain-disabled="{ disabled: !vpPaslagen, wholeDocumentExceptThisElement: false }"
					>
						<div class="_eui-collapsible_content_inner">

							<slot></slot>

						</div>
					</div>

				</div>
			`,

			// Props utöver de från mixin ovan:
			props: {
				chevronScale: {
					type: Number,
					default: 1,
				},
				chevronExtraMarginRight: {
					type: String,
					default: '0',
				},

				// Sätts som data-attribut (data-id=" ... ") på både collapsible-diven och dess input checkbox child:
				dataId: {
					type: String,
				}
			},

			computed: {
				chevronStyle() {
					return `
						margin-right: ${this.chevronExtraMarginRight};
					`;
				},
				chevronPictogramStyle() {
					return `
						transform: scale(${this.chevronScale});
					`;
				},
			},

			directives: {
				[euiMaintainDisabled.name]: euiMaintainDisabled,
			},

			created() {
				// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
				// Exempel: this.$_undertryckNastaAndradEvent = false;
			},

			mounted() {
				// Note that mounted does not guarantee that all child components have also been mounted.

				// För att klick på länkar inom label inte ska ätas upp av @click.stop.prevent på <label>:
				for (const a of this.$el.querySelectorAll('label a'))
				{
					a.addEventListener('click', function (e) {
						e.stopPropagation();
					});
				}

				//this.$nextTick(function () {
				//	// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
				//})
			},
		});
	}
};

export { plugin as euiCollapsible };
